// @flow
import * as React from "react"
import { RouteData, SiteData } from "react-static"
import { Header } from "./Header/index"
import { Footer } from "./Footer/index"
import { tRouteProps, tSiteProps } from "../types"
import { CartContextContainer } from "./CartContext/index"
import type { tRoute } from "../types"
import { hot } from "react-hot-loader"
import { wrapIframesInResponsiveVideo } from "../utils"
import FacebookPixel from "react-facebook-pixel"

export type tLayoutInner = tRoute & {
  children: ({}) => React.Node
}

export type tLayoutInnerState = {}

export class LayoutInner extends React.Component<
  tLayoutInner,
  tLayoutInnerState
> {
  componentDidMount() {
    wrapIframesInResponsiveVideo()
    // Facebook pixel
    FacebookPixel.init(
      "1866105383689579",
      {},
      {
        autoConfig: true,
        debug: false
      }
    )

    FacebookPixel.pageView()
  }
  render() {
    return (
      <React.Fragment>
        <Header routeProps={{ ...this.props }} />

        <main>{this.props.children(this.props)}</main>

        <Footer routeProps={{ ...this.props }} />
      </React.Fragment>
    )
  }
}

export type tLayoutContainer = {}

export type tLayoutContainerState = {}

export class LayoutContainer extends React.Component<
  tLayoutContainer,
  tLayoutContainerState
> {
  render() {
    return (
      <CartContextContainer>
        <SiteData>
          {(siteProps: tSiteProps) => (
            <RouteData>
              {(routeProps: tRouteProps) => (
                <LayoutInner {...this.props} {...siteProps} {...routeProps} />
              )}
            </RouteData>
          )}
        </SiteData>
      </CartContextContainer>
    )
  }
}

export const Layout = hot(module)(LayoutContainer)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Layout.js